/**
 * Feature flag string keys returned in `activeFeatureFlags` from PublicProductRpc.
 *
 * These are plain strings — NOT hub-http gate objects — because the public
 * feature-flags API returns a flat string array, not portal gate IDs.
 *
 * Usage: `featureFlags.includes(FeatureFlags.HUBSPOT_ON_CREDITS)`.
 */
export const FeatureFlags = {
  /** Portal is on the HubSpot-on-Credits billing model. */
  HUBSPOT_ON_CREDITS: 'hubspotoncredits',
  /** Portal has seats-based billing enabled. */
  SEATS: 'seats',
  /** Enables JSON-LD schema markup emission on public pricing pages. */
  PUBLIC_PRICING_PAGE_SCHEMA: 'PUBLIC_PRICING_PAGE_SCHEMA'
};